import React from 'react';
import { Link } from 'gatsby';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const Featured = props => {
    // Multiple featured recipe block
    const FeaturedPod = props => {
        let subDir = '';
        if (props.pagePath.indexOf('/celebrate') > -1) {
            subDir = '/celebrate';
        } else {
            subDir = '';
        }

        return (
            <Col
                xs={{ span: 10, offset: 1 }}
                sm={{ span: 8, offset: 2 }}
                md={{ span: 4, offset: 0 }}
                className="featured-pod"
            >
                <Link
                    to={`${props.langKey === 'en' ? '' : 'es/'}recipes/${
                        props.slug
                    }/`}
                >
                    <img
                        src={`${subDir}/recipes/featured/${props.slug}.png`}
                        alt={
                            props.langKey === 'en'
                                ? props.title
                                : props.title_es
                        }
                        className="featured-recipe"
                    />
                    <p className="featured-recipe-title">
                        {props.langKey === 'en' ? props.title : props.title_es}
                    </p>
                </Link>
                <Link
                    to={`${props.langKey === 'en' ? '' : 'es/'}recipes/${
                        props.slug
                    }/`}
                >
                    <button className="featured-recipe-button">
                        {props.langKey === 'en'
                            ? 'Get Recipe'
                            : 'Obtener receta'}
                    </button>
                </Link>
            </Col>
        );
    };

    // Single feature recipe block
    // const FeaturedPodMono = props => {
    //     return (
    //         <Col xs={12} className="featured-pod-mono">
    //             <Row>
    //                 <Col
    //                     xs={{ span: 10, offset: 1 }}
    //                     sm={{ span: 8, offset: 2 }}
    //                     md={{ span: 8, offset: 0 }}
    //                     lg={{ span: 6, offset: 1 }}
    //                     className="featured-pod-image"
    //                 >
    //                     <Link
    //                         to={`${
    //                             props.langKey === 'en' ? '' : 'es/'
    //                         }recipes/${props.slug}`}
    //                     >
    //                         <img
    //                             src={`/recipes/featured/${props.slug}.png`}
    //                             alt={
    //                                 props.langKey === 'en'
    //                                     ? props.title
    //                                     : props.title_es
    //                             }
    //                             className="featured-recipe"
    //                         />
    //                     </Link>
    //                 </Col>
    //                 <Col
    //                     xs={{ span: 10, offset: 1 }}
    //                     sm={{ span: 8, offset: 2 }}
    //                     md={{ span: 4, offset: 0 }}
    //                     lg={{ span: 3, offset: 0 }}
    //                     className="featured-pod-copy"
    //                 >
    //                     <Link
    //                         to={`${
    //                             props.langKey === 'en' ? '' : 'es/'
    //                         }recipes/${props.slug}`}
    //                     >
    //                         <p className="featured-recipe-title">
    //                             {props.langKey === 'en'
    //                                 ? props.title
    //                                 : props.title_es}
    //                         </p>
    //                         <button className="featured-recipe-button">
    //                             {props.langKey === 'en'
    //                                 ? 'Get Recipe'
    //                                 : 'Obtener receta'}
    //                         </button>
    //                     </Link>
    //                 </Col>
    //             </Row>
    //         </Col>
    //     );
    // };

    return (
        <section id="featured" className="to-blur">
            <Container>
                <Row>
                    <FeaturedPod
                        // Use FeaturedPod for multiple featured recipes on homepage.
                        title="Crunchy Plantain Chicken"
                        title_es="Pollo con Corteza de Plátano Crujiente"
                        slug="crunchy-plantain-chicken"

                        pagePath={props.pagePath}
                        langKey={props.langKey}
                    />
                    <FeaturedPod
                        title="Pork and Black Bean Tostadas"
                        title_es="Tostadas de Cerdo y Frijoles Negros"
                        slug="pork-and-black-bean-tostadas"
                        pagePath={props.pagePath}
                        langKey={props.langKey}
                    />
                    <FeaturedPod
                        title="Festive Empanadas"
                        title_es="Empanadas Festivas"
                        slug="festive-empanadas"
                        pagePath={props.pagePath}
                        langKey={props.langKey}
                    />
                    {/* <FeaturedPodMono
                        // Use FeaturedPodMono for single featured recipe on homepage
                        title="Red Wine and Guava-Braised Short Ribs"
                        title_es="Tira de Costilla Guisada con Vino Tinto y Guayaba"
                        slug="red-wine-guava-braised-short-ribs"
                        pagePath={props.pagePath}
                        langKey={props.langKey}
                    /> */}
                </Row>
            </Container>
        </section>
    );
};

export default Featured;
